import { ReactNode } from "react";
import { Icon, IconType } from "../../../icons/Icon";
import styles from "./EmptyState.module.scss";

interface IEmptyStateProps {
  icon?: IconType;
  title?: string;
  description?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
}

export const EmptyState = ({
  icon,
  title,
  description,
  actionLabel,
  onAction,
}: IEmptyStateProps) => {
  return (
    <div className={styles.root}>
      {icon && (
        <div className={styles.icon_wrap}>
          <Icon type={icon} width="26px" height="26px" />
        </div>
      )}
      {title && <h3 className={styles.title}>{title}</h3>}
      {description && <p className={styles.description}>{description}</p>}
      {actionLabel && onAction && (
        <button className={styles.action_btn} onClick={onAction} type="button">
          <Icon type={IconType.PlusIcon} width="13px" height="13px" />
          {actionLabel}
        </button>
      )}
    </div>
  );
};
